import type { Tag as TagProps } from "@amzn/ads-discovery-theme-service-typescript-client";
import { TagType } from "@amzn/ads-discovery-theme-service-typescript-client";
import { Tag } from "@amzn/storm-ui";
import React from "react";
import styled from "styled-components";

export const StyledTag = styled(Tag)<{ inline: boolean }>`
    ${(props) => props.inline && "bottom: 0px;"}
`;

export const TagComponent: React.FunctionComponent<TagProps> = (props) => {
    const { label, type = TagType.BETA, description, inline = false } = props;
    return (
        <StyledTag
            label={label}
            variant={type as TagType}
            description={description}
            inline={inline}
        />
    );
};
